import * as React from 'react';
import * as main from '../../../styles/main.module.scss';
import * as extra from './extra.module.scss';

export const Extra = () => {
  return (
    <section className={extra.extra}>
      <div className={"container"}>
        <div className={extra.extra__container}>
          <h2 className={main.mainTitle}>Какие дополнительные результаты вы получите</h2>
          <ul className={extra.extra__list}>
            <li className={extra.extra__item}>
              <img
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/dop-01.png"}
                alt={""}
              />
              <p className={extra.extra__text}>будете на одной волне со своими детьми и внуками</p>
            </li>
            <li className={extra.extra__item}>
              <img
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/dop-02.png"}
                alt={""}
              />
              <p className={extra.extra__text}>сможете приятно удивить близких, которые думают, что знают про вас всё</p>
            </li>
            <li className={extra.extra__item}>
              <img
                src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/dop-03.png"}
                alt={""}
              />
              <p className={extra.extra__text}>узнаете, как сделать свой следующий день рождения датой начала второй молодости</p>
            </li>
          </ul>
          <a href={"#widget"} data-target={"#widget"} className={`${main.mainBtn} ${extra.extra__btn}`}>Зарегистрироваться</a>
        </div>
        <div className={extra.extra__methods}>
          <div className={extra.extra__methodsInfo}>
            <p className={extra.extra__methodsTxt_main}>На вебинаре будут как общедоступные способы омоложения мозга, так и презентация авторских методик ЦОТ Advance</p>
            <p className={extra.extra__methodsTxt}>Всем, кто запишется на вебинар, пришлем бесплатные инструменты для омоложения и восстановления сил вашего мозга, чтобы вы могли попробовать их на себе до нашей встречи и уже имели собственный опыт!</p>
          </div>
          <img
            src={"https://fs.advance.ru/landing-pages/webinar/krp_molodostmozga/advance-photo.png"}
            className={extra.extra__methodsImg}
            alt={""}
          />
        </div>
      </div>
    </section>
  );
};
